
<template>
    <div>
        <div class="row">
            <div class="col-md-6 mb-4">
                <h1>{{ $t("signoff-anomalies") }}</h1>
            </div>
            <div class="col-md-6" v-if="!submitting">
            	<div class="float-right">
					<SelectInput
						:label="$t('filter-by-score')"
						:options="scores"
						:nullLabel="$t('filter-by-score')"
						:nullable="true"
						v-model="filters.score"
						:srOnly="true"
						@input="filterByScore()"
						class="d-inline-block mt-0 mb-0 align-middle"
					   >
					</SelectInput>
                    <button
                    	class="btn-success btn mt-0 ml-2 d-inline-block align-middle"
                        @click = "markAllPresent()"
                        v-if="markAll && anomalies.length>0"
                    >
                        {{ $t('mark-{n}-present',{n:this.filters.total}) }}
                    </button>
				</div>
            </div>
        </div>

        <!-- START NO ANOMALIES / SCORE MATCH -->
        <div v-if="anomalies.length === 0 && !submitting">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
                        <div class="card-body text-center">
                            <b-icon icon="check-circle-fill" variant="success" font-scale="7.5" class="mb-2"></b-icon>
                            <h5 class="card-title">{{  $t("nothing-to-display")  }}</h5>
                            <p class="card-text">
                                {{ !filters.score ? $t('there-are-no-anomalies-to-display')
                                 :  $t('there-are-no-anomalies-matching-that-score') }}
                            </p>
                            <button class="btn-primary btn mt-4 mb-3"
                                    @click = "filters.score=null; listAnomalies()"
                                    v-if="filters.score"
                                >
                                    {{ $t('see-all') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END NO ANOMALIES -->
        <div v-else class="list-group no-border border-radius-2 mt-2">
            <ScrollPaginator
                :data="anomalies"
                :submitting="submitting"
                :filters="filters"
                @toPage="toPage"

            >
                <template v-slot:item="{item: anomaly}">
                    <div class="list-group-item">
                        <div class="clearfix row" @click="details[anomaly.id] = !details[anomaly.id]">
                            <!-- START EVENT INFO-->
                            <div class="col-md-3 col-xl-3">
                                <!-- START EVENT INFO-->
                                <div class="small text-center">
                                    <p class="mb-0"><strong>{{ anomaly.formattedDatetime }}</strong></p>
                                    <p class="mb-1"> {{ getEventName( anomaly.ttevent_id) }}</p>
                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-sm mb-2"
                                        @click="$router.push(`/attendance/register/${anomaly.ttevent_id}`)"
                                    >
                                        {{ $t('view-attendance-register') }}
                                    </button>
                                </div>
                                <!--END EVENT INFO-->
                            </div>
                            <!--END EVENT INFO-->

                            <!-- START STUDENT INFO-->
                            <div class="col-md-3 col-xl-5">
                                <div class="row">
                                    <div class="col-xl-6 small text-center text-md-left">
                                        <Avatar
                                            class="avatar float-left mr-4 mb-3 lg:mb-0"
                                            :userId="anomaly.userfrom_id"
                                        />
                                        <div class=" mr-4 mb-0 "  v-if="getUser(anomaly.userfrom_id)">
                                            <p class="mb-0"><strong>
                                                {{ getUser(anomaly.userfrom_id).displayName}}
                                            </strong></p>
                                            <p class="mb-0">
                                                {{ `${$t('year-colon')} ${ getUser(anomaly.userfrom_id).year}, ${$t('programme-colon')}
                                                                                ${ getUser(anomaly.userfrom_id).programme}`
                                                }}

                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 text-center text-md-left">
                                        <p class="small mb-0" v-if="toleranceRadius">
                                            <b-icon :icon="anomaly.subdist <= toleranceRadius ?
                                                'check-circle-fill' : 'exclamation-circle-fill'"
                                                :variant="(anomaly.submitterdistance <= toleranceRadius && checkCoords(anomaly.id) && checkCoords(anomaly.id,'location'))
            ? 'success' : 'warning'">
                                            </b-icon>
                                            {{ $t('submitter-distance') }}
                                            {{ checkCoords(anomaly.id) && checkCoords(anomaly.id,'location') ? `${Math.ceil(anomaly.submitterdistance)}m.` :
                                                    $t('no-data') }}
                                        </p>
                                        <p class="small mb-0" v-if="toleranceRadius">
                                            <b-icon :icon="anomaly.signdist <= toleranceRadius ?
                                                'check-circle-fill' : 'exclamation-circle-fill'"
                                                :variant="(anomaly.signerdistance <= toleranceRadius && checkCoords(anomaly.id,'signer') && checkCoords(anomaly.id,'location'))
            ? 'success' : 'warning'">
                                            </b-icon>
                                            {{ $t('signer-distance') }}
                                            {{ checkCoords(anomaly.id,'signer') && checkCoords(anomaly.id,'location') ? `${Math.ceil(anomaly.signerdistance)}m.` :
                                                    $t('no-data') }}
                                        </p>
                                        <p class="small mb-2">
                                            <b-icon :icon="anomaly.signerdistance ?
                                                'check-circle-fill' : 'exclamation-circle-fill'"
                                                :variant="anomaly.signerdistance ? 'success' : 'warning'">
                                            </b-icon>
                                            {{ $t('signed-off') }}
                                            {{ anomaly.signerdistance ? $t('yes') : $t('no') }}
                                        </p>
                                    </div>

                                </div>
                            </div>
                            <!--END STUDENT INFO-->

                            <!--START SCORE-->
                            <div class="col-xl-1 col-md-2 text-center">
                                <b-badge style="font-size: 2rem;"
                                    :variant="anomaly.score <= Number(threshold/2) ? 'danger' : 'warning'">
                                    {{ anomaly.score }}
                                </b-badge>
                                <h6 class="card-title mt-2">{{ $t('score') }}</h6>
                            </div>
                            <!--END SCORE-->
                            <!--START ACTIONS-->
                            <div class="col-xl-3 col-md-4 ">
                                <div class="btn-group text-md-right text-center mt-3" style="display: block" v-if="getUser(anomaly.userfrom_id)">
                                    <button class="btn btn-on-good btn-off"
                                        @click.stop="updateAttendance(anomaly.id, anomaly.userfrom_id, anomaly.ttevent_id, true)"
                                        :class="attendedClass(anomaly.id)">
                                        {{ $t('attended') }}
                                    </button>
                                    <button class="btn btn-on-bad btn-off"
                                        @click.stop="updateAttendance(anomaly.id, anomaly.userfrom_id, anomaly.ttevent_id, false)"
                                        :class="absentClass(anomaly.id)">
                                        {{ $t('not-attended') }}
                                    </button>
                                </div>

                            </div>

                            <!--END ACTIONS-->
                        </div>
                        <!-- START DETAILS-->
                        <b-collapse id="collapse-4" v-model="details[anomaly.id]" class="mt-2">
                            <b-row>
                                <b-col cols="12" class="mt-3">
                                    <b-card-group class="mb-2" deck>
                                        <b-card no-body :header="$t('external-signer-id-colon-{id}', { id: anomaly.id })">
                                            <b-list-group flush>
                                                <b-list-group-item href="#"><strong>{{ $t('name-colon') }} </strong> {{
                                                    anomaly.name }}</b-list-group-item>
                                                <b-list-group-item href="#"><strong>{{ $t('email-colon') }} </strong> {{
                                                    anomaly.email }}</b-list-group-item>
                                                <b-list-group-item href="#"><strong>{{ $t('phone-colon') }} </strong> {{
                                                    anomaly.phone }}</b-list-group-item>
                                                <b-list-group-item href="#"><strong>{{ $t('registration-number-colon') }} </strong>
                                                    {{ anomaly.regno }}</b-list-group-item>
                                            </b-list-group>
                                        </b-card>
                                        <b-card no-body :header="$t('event-id-colon-{id}', { id: anomaly.ttevent_id })">
                                            <b-list-group flush>
                                                <b-list-group-item href="#"><strong>{{ $t('event-lat-colon') }} </strong> {{
                                                    anomaly.locationlat }}</b-list-group-item>
                                                <b-list-group-item href="#"><strong>{{ $t('event-long-colon') }} </strong> {{
                                                    anomaly.locationlong }}</b-list-group-item>
                                            </b-list-group>
                                        </b-card>
                                        <b-card no-body :header="$t('coordinates')">
                                            <b-list-group flush>
                                                <b-list-group-item href="#"><strong>{{ $t('submitter-lat-colon') }} </strong> {{
                                                anomaly.lat }}</b-list-group-item>
                                                <b-list-group-item href="#"><strong>{{ $t('submitter-long-colon') }} </strong> {{
                                                    anomaly.long }}</b-list-group-item>
                                                <b-list-group-item href="#"><strong>{{ $t('signer-lat-colon') }} </strong> {{
                                                    anomaly.signerlat }}</b-list-group-item>
                                                <b-list-group-item href="#"><strong>{{ $t('signer-long-colon') }} </strong> {{
                                                    anomaly.signerlong }}</b-list-group-item>
                                            </b-list-group>
                                        </b-card>
                                    </b-card-group>
                                    <Map :id="Number(anomaly.id)" v-if="details[anomaly.id] && someCoords(anomaly.id)" :toleranceRadius="toleranceRadius"
                                        :coords="parseCoordinates(anomaly)"></Map>
                                </b-col>
                            </b-row>
                        </b-collapse>
                        <!--END DETAILS-->
                    </div>
                </template>
		    </ScrollPaginator>
        </div>

        <div v-if="submitting">
            <div class="list-group-item list-group-item-action" v-for="item in Array(5)" v-bind:key="item">
                <div class="clearfix row align-items-center">
                    <div class="col-md-12">
                        <div class="card border-0">
                            <div class="card-body">
                                <table class="w-100">
                                    <tr>
                                        <td>
                                            <div class="skeleton midnight h32 w-100 rounded mb-1"></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>
<script>
import Avatar from "src/components/Avatar.vue";
import Map from '/src/components/Map.vue'
import ScrollPaginator from "../../components/Table/ScrollPaginator.vue";

export default {
    components: {
        Avatar,
        Map,
        ScrollPaginator
    },
    data() {
        return {
            current_score: null,
            filters: {
                page: 1,
                page_size: 6,
                total:0,
                search: '',
                sort: '',
                order: '',
                score: null
            },
            anomalies: [],
            toleranceRadius: null,
            threshold:null,
            submitting: false,
            details: {},
            attendance: {},
            ttsessiontypes:[],
            ttrooms:{},
            scores:[],
            markAll:false,
            accAnomalies:[]
        }

    },
    created(){
        this.listAnomalies();
        this.getUsers();
        this.getTTSessionTypes();
        this.scoreOptions();
    },

    methods: {
        listAnomalies(markallattended = false ) {

            if (this.submitting) return;

            this.submitting = true;

            this.filters['mark_all_attended'] = false;
            if(markallattended) this.filters['mark_all_attended'] = true;

            this.$cfetch(`${this.$settings.APIBaseURL}/attendance/listattendanceanomalies`, {
                method: "post",
                data: this.filters
            })
                .then((res) => {
                    
                    this.submitting = false;
                    if (res.status === "SUCCESS") {

                        this.anomalies =  res.results.map(item => {
                            return {
                            ...item,
                            formattedDatetime: this.$datetime.getLocaleStringFromTimeStamp(item.datetime),
                        }}
                        );

                        this.accAnomalies = [
                            ...this.accAnomalies,
                            ...res.results
                        ]
                        // Store the tolerance radius
                        this.toleranceRadius = res.toleranceradius;

                        // Store the threshold s
                        this.threshold = res.threshold;

                        // Store current score

                        this.current_score = res.current_score;

                        // Get all the ttrooms involved
                        this.ttrooms={
                            ...this.ttrooms,
                            ...res.ttrooms,

                        };

                        // Stop loading
            			this.markAll = true;

                        // Filtering and all that
                        if(res.results.length>0){
                            this.filters.page = res.pagination.page
                            this.filters.page_size = res.pagination.page_size
                            this.filters.total = res.pagination.total
                        }

                    } else {
                        this.$log.info.call(this, status)
                    }

                }).catch(error => {
                    this.submitting = false;
                    this.$log.error.call(this, error);
                });
        },
        getUser(id){
            if(id && this.users){
                for (let key in this.users){
                    if(Number(id) == this.users[key].id){
                        return this.users[key] || {};
                    }
                }
            }
        },
        getUsers() {
            this.$cfetch(`${this.$settings.APIBaseURL}/getusers`,
                {
                    method: "post",
                    data: {
                        priv: 'APP_STUDENT'
                    }
                }
            )
            .then(res => {
                if (res.status == "SUCCESS") {
                	this.users = res.users;
                }
            })
            .catch(error => {
                this.$log.error.call(this, error);
            });
		},
        updateAttendance(id, user_id, ttevent_id, status) {
            this.$set(this.attendance, id, status);
            this.$cfetch(`${this.$settings.APIBaseURL}/timetable/register/saveattendance`, {
                data: {
                    'ttevent_id': Number(ttevent_id),
                    'student_id': user_id,
                    'status': status,
                },
            }).then((res) => {
                if (res.status === "SUCCESS") {
                   if(!this.filters.score) this.$set(this.attendance, id, status);
                } else {
                    this.somethingWentWrong();
                    this.attendance[id] = null;
                }
            }).catch(() => {
                this.somethingWentWrong();
            });

        },
        markAllPresent(){
            if(this.markAll && this.anomalies.length > 0){

                this.anomalies =[];
                this.attendance ={};
                this.submitting = false;
                this.markAll= false;

                this.listAnomalies(true);

            }
        },
        somethingWentWrong() {
            this.$store.commit("openDialog", {
                cancelBtn: true,
                title: this.$t("oops"),
                content: this.$t("something-went-wrong")
            });
        },
        parseCoordinates(anomaly) {
            const convertCoordinate = (key) => {
                const latKey = `${key}lat`;
                const longKey = `${key}long`;
                return {
                    lat: anomaly[latKey] ? Number(anomaly[latKey]) : null,
                    long: anomaly[longKey] ? Number(anomaly[longKey]) : null,
                };
            };
            return {
                submitter: convertCoordinate(''),
                signer: convertCoordinate('signer'),
                location: convertCoordinate('location'),
            };
        },
        getTTSessionTypes() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/sessiontypes/all`, {
                data: {
                },
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.ttsessiontypes= res.results;
                } else {
                    this.somethingWentWrong();
                }
            }).catch(() => {
                this.somethingWentWrong();
            });
        },
        getEventName(ttevent_id){
            let ttsessiontype_rooms ={}
            for (const session of this.ttsessiontypes){
                if(session.ttrooms.length>0){
                    for (const room of session.ttrooms){
                        if(room.id == this.ttrooms[ttevent_id]){
                            ttsessiontype_rooms[room.id]=room.name;
                            return `${session.name} ${this.$t('at')} ${room.name}`;
                        }
                    }
                }
            }
        },
        scoreOptions(){
            for (let i = 0; i <= 100; i += 10) {
                this.scores.push(i);
            }
        },
        filterByScore(){
            this.markAll = false;
            this.filters.page = 1;
            this.anomalies =[];
            this.attendance = {};
            this.listAnomalies();
        },
        toPage(pageNo) {
            this.filters.page = pageNo;
            this.listAnomalies()
        },
        someCoords(id) {//Checks if at least a set of coords is defined

            let propertiesToCheck = ['lat', 'long', 'signerlat', 'signerlong', 'locationlat', 'locationlong'];

            let anomaly = this.accAnomalies.find(obj => obj.id == id);
            const empty = propertiesToCheck.every(key =>
                anomaly && (anomaly[key] == undefined || anomaly[key] == null || anomaly[key] == '')
            );
            if (empty) {
                return false;
            } else {
                return true;
            }

        },
        checkCoords(id,type='') {
            if(this.accAnomalies && id ){
                let anomaly = this.accAnomalies.find(obj => obj.id == id);
                if(anomaly && anomaly[`${type}lat`] && anomaly[`${type}long`]) {
                    return true;
                }
                return false;
            }
            return false;

        },
    },
    computed: {
        attendedClass() {
            return (id) => {
                if (this.accAnomalies.find(obj => obj.id === id)) {
                    return {
                        'btn-on': this.attendance[id] === true,
                        'btn-off': this.attendance[id] === false,
                    };
                } else {
                    return '';
                }
            };
        },
        absentClass() {
            return (id) => {
                if (this.accAnomalies.find(obj => obj.id === id)) {
                    return {
                        'btn-on': this.attendance[id] === false,
                        'btn-off': this.attendance[id] === true,
                    };
                } else {
                    return '';
                }
            };
        },

    }
};
</script>
<style>
.card {

    background-color: none !important;

}
</style>
